export const getTextContentByHTML = (html = '') => {
    const dom = new DOMParser().parseFromString(html, 'text/html')
    return (dom.body.textContent || '').replace(/\n/g, "")
}
